module.exports = __webpack_public_path__ + "static/media/seguro.5959fdf4.pdf";